<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputPrice" });
import { currency, percentage } from "../../../../common/format.js";
export let discount = void 0;
export let price = void 0;
export let currencyCode = "EUR";
export let unit = void 0;
</script>

{#if discount !== undefined && discount > 0}
    At least { percentage(discount, 2) } off
{:else if price !== undefined && unit !== undefined}
    { `${ currency(price, currencyCode) } / ${ unit === 'unit' ? 'item' : 'kg' } at most` }
{:else}
    -
{/if}